<h2 mat-dialog-title> <one-icon name="alert-circle"></one-icon> Your account has been locked</h2>
<div mat-dialog-content>
  <p>We've detected some unusual activity on your account. Please message our Live Chat to help resolve the issue.</p>
</div>
<div mat-dialog-actions class="d-flex justify-content-end">
  <button class="pf-button filled sm blue" (click)="onLiveChatClick($event)" cdkFocusInitial>Live Chat</button>
</div>
